// eslint-disable-next-line node/file-extension-in-import -- needs to disambiguate with .svelte
import Flow from './Flow.js';

export default function dialog(component, props = {}) {
  return new Flow((driver) => driver.render(component, props));
}
